import * as angular from "angular";
import { ApiUserService } from "../../services/user.service";
import { DialogUtils } from "../../helper/dialog.helper";
import { ToastUtils } from "../../helper/toast.helper";

let EditProfile = {
    selector: "vcEditProfile",
    templateUrl: "/angular/components/profile/edit-profile.component.html",
    bindings: {
        user: "=",
    },
    controller: class EditProfileController {
        // * bindings for typescript compiler *
        public user: any;
        // ************************************

        public saving = false;
        public errorMessage: string | boolean = false;

        private $cookies: any;
        private __env: any;

        private apiUserService: ApiUserService;
        private dialog: DialogUtils;
        private toast: ToastUtils;

        constructor(
            $cookies: any,
            __env: any,
            ApiUserService: ApiUserService,
            DialogUtils: DialogUtils,
            ToastUtils: ToastUtils
        ) {
            this.$cookies = $cookies;
            this.__env = __env;

            this.apiUserService = ApiUserService;
            this.dialog = DialogUtils;
            this.toast = ToastUtils;
        }

        $onInit() {
            if (this.user.email_confirmation != null) {
                if (this.user.email_confirmation.pendingemail != null) {
                    this.user.pendingemail =
                        this.user.email_confirmation.pendingemail;
                } else {
                    if (this.user.uemail) {
                        this.user.pendingemail = this.user.uemail;
                    }
                }
            }
        }

        cancel(): void {
            this.dialog.cancel();
        }

        confirm(): void {
            this.saving = true;
            this.apiUserService.update(this.user).then((response: object) => {
                let json = response["data"];
                if (json.success) {
                    this.errorMessage = false;
                    this.user.ufname = json.data.ufname;
                    this.user.ulname = json.data.ulname;
                    this.$cookies.put("ufname", this.user.ufname, {
                        domain: "." + this.__env.host,
                        path: "/",
                    });
                    this.$cookies.put("ulname", this.user.ulname, {
                        domain: "." + this.__env.host,
                        path: "/",
                    });
                    this.toast.success("Profile Updated");
                    this.dialog.hide(this.user);
                } else {
                    this.errorMessage = "Something went wrong";
                    if (json.message) {
                        this.errorMessage = json.message;
                    }
                    this.saving = false;
                }
            });
        }
    },
};

angular.module("profile").component(EditProfile.selector, EditProfile);
